import { render, staticRenderFns } from "./KnowledgeUnitListView.vue?vue&type=template&id=72d1404e&"
import script from "./KnowledgeUnitListView.vue?vue&type=script&lang=js&"
export * from "./KnowledgeUnitListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports